(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('ResourcesService', ['$http', ResourcesServiceFn]);

    /* resource service for loading defined resources by language */
    function ResourcesServiceFn($http) {
        var baseUrl = '/api/resources/';
        var service = {
            predefinedTaskTexts: predefinedTaskTexts,
            predefinedAppointmentTexts: predefinedAppointmentTexts,
            getDefaultAgendaText: getDefaultAgendaText
        };

        return service;

        /* list predefined text for task part by language */
        function predefinedTaskTexts() {
            return $http.get(baseUrl + 'tasks').then(function (response) {
                return response.data;
            });
        }

        /* list predefined text for task part by language */
        function predefinedAppointmentTexts() {
            return $http.get(baseUrl + 'appointments').then(function (response) {
                return response.data;
            });
        }

        function getDefaultAgendaText(fieldName, languageId) {
            return $http.get(`${baseUrl}agendas/default-text/${fieldName}/${languageId}`)
                        .then(function (response) {
                            return response.data;
                        });
        }

    } // ResourceFn
})();